export const testimonies = {
  step4: (
    <>
      <p className="leading-6">
        Home Instead has been helping my mother for well over a year now and
        have given her incredible care, love and support. Their attention to
        detail and patience to her needs is amazing.
      </p>
      <p className="font-bold text-md">— David C.</p>
    </>
  ),
  step5: (
    <>
      <p className="leading-6">
        My fathers caregiver was the perfect match for dad. She took good care
        of him and we could breathe a sigh of relief knowing he was being well
        cared for. We will definitely recommend Home Instead to anyone we know
        that is looking for care.
      </p>
      <p className="font-bold text-md">— Donna M.</p>
    </>
  ),
};
